import axios from 'axios'
import { useHistory, useParams } from 'react-router'
import { authContext } from '../../context/AuthContext'
import Loading from '../helper/Loading';
import PageHeader from '../helper/PageHeader';
import SimpleTable from '../helper/SimpleTable';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import Grid from '@mui/material/Grid';
import Alert from '@mui/material/Alert';
import Autocomplete from '@mui/material/Autocomplete';
import Button from '@mui/material/Button';
import DeleteDialog from '../helper/Dialogs';
import withStyles from '@mui/styles/withStyles';
import styles from "../styles";
import React, { useEffect, useState, useContext,  Fragment } from 'react'

const EmployerAdmin = props => {

    const history = useHistory();
    const params = useParams();
    const context = useContext(authContext)

    const { classes } = props;

    const [loading, setLoading] = useState(true)


    const [infoContacts, setInfoContacts ] = useState({
            email: '',
            users: [],
            info: null,
            error: null,
            selectedUser: undefined,
            contacts: [],
            isDeleteDialogOpen: false,
            itemToDelete: '',
        
    });

    const [groupData, setGroupData] = useState({
            groupName: '',
            groupType: 'Employer',
            groupContact: undefined,
            groupID: params.id,
    });

    
    
    useEffect(()=>{
        setLoading(false);
        function getGroupInformation(){

            if ( params.id !== undefined) {
    
                setLoading(true)
                  axios.get('/api/userGroup/' + params.id, {
                  }).then((res) => {
                      let group = res.data;
    
                      setGroupData(prevState =>{
                          return {...prevState,
                              groupName: group.usergroup.name,
                              groupType: group.usergroup.type,
                              groupContact: group.usergroup.contact,
                          }});
                     
                      setLoading(false)
                     
      
                      // console.log('group Data from render after userGroup', groupData );
                      // console.log('loading state after getting group info', loading);
      
                  }).catch(error => {
      
                    setInfoContacts(prevState =>{
                          return {...prevState, error: error.message }
                      });
                      setLoading(false)
                      
      
                  });
    
                  let url = '/api/groupuser/users/' + params.id ;
                  axios(url, {
                      method: 'GET'
                  }).then(res => res.data)
                      .then(result => {
                          let contacts = result.users.filter((u) => u.memberType === 'Owner');
                          console.log('the output contacts', contacts);
      
                          setInfoContacts(prevState =>{
                              return {...prevState, contacts: contacts }
                          });
                          // console.log('the updated contacts in infoData', infoContacts.contacts);
      
                          setLoading(false)
      
                      }).catch(error => {
      
                          setInfoContacts(prevState =>{
                              return {...prevState, error: error.message }
                          });
      
                          console.log('error in retriing contacts', error, 'in infoconatacts', infoContacts.error);
      
                          setLoading(false)
      
                      });
    
              } else {
                  console.log("In else")
              }
        }
        getGroupInformation();

        ValidatorForm.addValidationRule('isValueSelected', (value) => {
            console.log('here is the value select', value)
            if (value === undefined) {
                return false;
            }
            return true;
        });
            
    }, [infoContacts.error, params.id]);

    // Move to below header or somewhere else
    //if (info.contacts.length === 0) return <NoDataFound message="No contacts found" />;

    const onSetDefaultGontact = (tag) => {
        let userid = tag;
        var data = {
            groupContact: userid,
        }

        let token = sessionStorage.getItem('accessToken');
        axios('/api/usergroup/setContact/' + groupData.groupID, {
            method: 'POST',
            data: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then(response => {
            if (response.status >= 400) {
                throw new Error(response.statusText);
            }
            setGroupData(prevState =>{
                return {...prevState, groupContact: userid }
            });
        }).catch(err => {
            setInfoContacts(prevState =>{
                return {...prevState, error: err.message }
            });
        });

    }

    const handleDeleteDialogClose = () => {
      
        setInfoContacts(prevState =>{
                 return {...prevState, isDeleteDialogOpen: false }
             });
         };

    const handleDeleteDialogOpen = () => {

        setInfoContacts(prevState =>{
            return {...prevState, isDeleteDialogOpen: true }
        });
    };

    const openDeleteDialog = (tag) => {

        setInfoContacts(prevState =>{
            return {...prevState, itemToDelete: tag }
        });
        handleDeleteDialogOpen();
    }

    const onSearchUser = (event) => {

        axios.get('/api/user/search?email=' + infoContacts.email, {
        }).then(((result) => {
            result = result.data;
            let users = [];
            let msg = null;

            if (result.users.length > 0) {
                result.users.map((u) =>
                    users.push({ label: u.last_name + ', ' + u.first_name + ' - ' + u.username, value: u.username })
                );
            } else {
                msg = "User account not found. Check email or ask this person to create an account"
            }
            setInfoContacts(prevState =>{
                return {...prevState, 
                    info: msg, 
                    users: users,
                    selectedUser: undefined
                }
            });

        })).catch(error => {
            console.log("error:" + error);
        });
    }

    const onAddContact = async (event) => {
        let selectedUser = infoContacts.selectedUser['value'];
        console.log(selectedUser);
        let alreadyInGroup = infoContacts.contacts.find((u) => u.id === selectedUser);
        console.log(infoContacts.contacts);
        console.log('already in group', alreadyInGroup);
        if (alreadyInGroup) {
             setInfoContacts(prevState =>{
                return {...prevState, error: "this user is already an admin in this employer" }
            });
             return
        }
        let data = {
            groupID: groupData.groupID,
            groupContact: groupData.groupContact,
            groupType: 'Employer',
            username: infoContacts.selectedUser['value'],
            memberType: 'Owner',
            addedBy: context.user.username
        }
        console.log(data);
        try {
            await axios('/api/groupuser/', {
                method: 'POST',
                data: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': context.accessToken
                }
            });
            let url = '/api/groupuser/users/' + groupData.groupID;
            let res = await axios.get(url, {});
            let contacts = res.data.users.filter((u) => u.memberType === 'Owner');
            setInfoContacts(prevState =>{
                return {...prevState, 
                    contacts: contacts,
                    email: '',
                    selectedUser: undefined,
                    users: []
                 }
            });
        } catch (err) {
            console.log(err);
            setInfoContacts(prevState =>{
                return {...prevState, error: err.message }
            });
        }
    }

    

    const onRemoveContact = (event) => {

        handleDeleteDialogClose();
        let username = infoContacts.itemToDelete;

        setInfoContacts(prevState =>{
            return {...prevState, itemToDelete: '' }
        });

        let token = sessionStorage.getItem('accessToken');
        let url = '/api/groupuser/' + groupData.groupID + '/' + username;
        axios(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
        }).then(response => {
            if (response.status >= 400) {
                throw new Error(response.statusText);
            }
            let url = '/api/groupuser/users/' + groupData.groupID;
            axios(url, {
                method: 'GET'
            })
                .then(res => res.data)
                .then(result => {
                    let contacts = result.users.filter((u) => u.memberType === 'Owner');
                    setInfoContacts(prevState =>{
                        return {...prevState, contacts: contacts }
                    });
                });
        }).catch(err => {
         setInfoContacts(prevState =>{
                return {...prevState, error: err.message }
            });
        });
    }

   
    const hideError = () => {
        setInfoContacts(prevState =>{
            return {...prevState, error: '' }
        });
    }

    const handleChange = event => {
        setInfoContacts(prevState =>{
            return {...prevState, [event.target.name]: event.target.value }
        });
    }

    const hideInfo = () => {

        setInfoContacts(prevState =>{
            return {...prevState, info: '' }
        });
    }

    const onUserSelect = (name, value) => {
        let selected = value;

        if (selected === null) {
            setInfoContacts(prevState =>{
                return {...prevState, selectedUser: '' }
            });
            
            return;
        }

        setInfoContacts(prevState =>{
            return {...prevState, selectedUser: JSON.parse(JSON.stringify(selected)) }
        });

    }
    console.log('state.contacts data', infoContacts.contacts);

    let enhancedData = [];
    enhancedData = infoContacts.contacts.map((arrayItem) => {
        let item = JSON.parse(JSON.stringify(arrayItem));
        item.isGroupContact = (item.id === groupData.groupContact) ? 'Yes' : 'No';
        item.actionsDisabled = {
            makeDefaultContact: (item.memberType !== 'Owner') || (item.id === groupData.groupContact),
            delete: item.id === groupData.groupContact
        }
        return item;
    });

    const tableCells = [
        { id: 'name', label: 'Name', centered: false },
        { id: 'id', label: 'UserName', centered: false },
        { id: 'email', label: 'Email', centered: false },
        { id: 'isGroupContact', label: 'Primary Contact?', centered: true }
    ];

    const actionButtons = [
        { icon: "makeDefaultContact",  label:'Make Primary', action: onSetDefaultGontact, delete: false },
        { icon: "delete",  label:'Delete', action: openDeleteDialog, delete: true }
    ];


    return <>
    {
        loading 
        ? 
        <Loading />
        : 
        <Fragment>
        <PageHeader
             title={"Manage Employer Admin for " + groupData.groupName }
             cancel={history.goBack}
        />
        <Grid container  justifyContent="space-around"  alignItems="center">

            <Grid item xs={12} md={8} style={{ textAlign: "left", alignSelf: "flex-start" }}>
                <p>All Employer Users will be able to:</p>
                <ul>
                    <li>Add credit to the Employer account (via credit card purchase) and view purchase history</li>
                    <li>Assign credit to a specific employee for online training/test</li>
                    <li>View employees' online training progress and history, including certificate ID (after issue)</li>
                    <li>Add or remove other users</li>
                </ul>
            </Grid>
        </Grid>
        <h6>
        Enter email address, then click search. Select name from the list, then click Add Admin</h6>
        {infoContacts.error &&
        <div>
            <Alert severity="error" onClose={hideError}>{infoContacts.error}</Alert>
        </div>
        }
        <ValidatorForm
            noValidate
            onSubmit={onAddContact}
        >

            {infoContacts.info &&
                <div>
                    <Alert severity="error" onClose={hideInfo}>{infoContacts.info}</Alert>
                </div>
            }

            <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                    <TextValidator
                        label="Enter email to search for account"
                        type="email"
                        name='email'
                        value={infoContacts.email}
                        className={[classes.textField].join(' ')}
                        onChange={handleChange}
                        validators={['required', 'isEmail']}
                        errorMessages={['Email is required', 'Please enter a valid email address']}
                        fullWidth
                        required
                    />
                </Grid>
                <Grid item xs={12}  md={2} style={{ textAlign: "center", alignSelf: "flex-end" }}>
                    <Button 
                    variant="contained" 
                    color="primary" 
                    className={[].join(' ')} 
                    onClick={ onSearchUser}
                >
                    Search
                    </Button>
                </Grid>
                <Grid item xs={12}  md={4}>
                    {console.log('autocomplete info', infoContacts) }
                    <Autocomplete
                        id="user"
                        options={infoContacts.users}
                        getOptionLabel={(option) => option.label}
                        // getOptionSelected={(option, val) => val === "" || option.value === val}
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        value={infoContacts.selectedUser || { label: "" }}
                        onChange={onUserSelect}
                        className={[classes.autoComplete].join(' ')}
                        renderInput={(params) => <TextValidator {...params}
                            label="Select user account to add"
                            value={infoContacts.users.length === 0 ? "-" : infoContacts.selectedUser}
                            validators={['required', 'isValueSelected']}
                            errorMessages={['Please select a user account', 'Please select a user account']}
                            required
                        />}
                        disabled={infoContacts.users.length === 0}
                    />
                </Grid>
                <Grid item xs={12}  md={2} style={{ textAlign: "center", alignSelf: "flex-end" }}>
                    <Button 
                    variant="contained" 
                    color="primary" 
                    className={[].join(' ')} 
                    disabled={ infoContacts.selectedUser === undefined}
                    type="submit" 
                    >
                    Add Admin
                    </Button>
                </Grid>
               
            </Grid>
            {infoContacts.users &&
            <p>Found {infoContacts.users.length} users </p>
            }

            <SimpleTable
                data={enhancedData}
                cellKey={"id"}
                tableCells={tableCells}
                actionButtons={actionButtons}
                actions={true}
            /> 
            <DeleteDialog
                open={infoContacts.isDeleteDialogOpen}
                onClose={handleDeleteDialogClose}
                onDelete={onRemoveContact}
            />
        </ValidatorForm>
    </Fragment>
    }
    </>;
}

export default withStyles(styles, { withTheme: true })(EmployerAdmin);
//export default TrainingHist
